export const MAP_LAYER_IDS = {
  background: 'background',
  links: 'links',
  shapes: 'shapes',
  regions: 'regions',
  pins: 'pins',
  drawings: 'drawings',
};

export const getDefaultMapState = () => ({
  version: 1,
  background: {
    imageId: '',
    url: '',
    width: 0,
    height: 0,
    fit: 'contain',
    opacity: 1,
  },
  grid: {
    visible: false,
    size: 50,
    color: 'contrast',
    opacity: 0.16,
  },
  viewport: {
    x: 0,
    y: 0,
    zoom: 1,
  },
  layers: [
    {
      id: MAP_LAYER_IDS.background,
      label: 'Fond',
      type: 'background',
      visible: true,
      locked: false,
    },
    {
      id: MAP_LAYER_IDS.links,
      label: 'Traits',
      type: 'links',
      visible: true,
      locked: false,
    },
    {
      id: MAP_LAYER_IDS.shapes,
      label: 'Formes',
      type: 'shapes',
      visible: true,
      locked: false,
    },
    {
      id: MAP_LAYER_IDS.regions,
      label: 'Régions',
      type: 'regions',
      visible: true,
      locked: false,
    },
    {
      id: MAP_LAYER_IDS.pins,
      label: 'Pins',
      type: 'pins',
      visible: true,
      locked: false,
    },
    {
      id: MAP_LAYER_IDS.drawings,
      label: 'Dessins',
      type: 'drawings',
      visible: true,
      locked: false,
    },
  ],
  pins: [],
  links: [],
  shapes: [],
  regions: [],
  drawings: [],
  groups: [],
  measurements: [],
  measureScales: [],
  activeMeasureScaleId: null,
  activeMeasureScaleIds: [],
});

export const normalizeMapState = rawMap => {
  const defaults = getDefaultMapState();
  const next = {
    ...defaults,
    ...(rawMap || {}),
    background: {
      ...defaults.background,
      ...(rawMap?.background || {}),
    },
    grid: {
      ...defaults.grid,
      ...(rawMap?.grid || {}),
      visible: rawMap?.grid?.visible === true,
      size:
        Number(rawMap?.grid?.size) > 0
          ? Math.round(Number(rawMap.grid.size))
          : defaults.grid.size,
      color:
        typeof rawMap?.grid?.color === 'string' && rawMap.grid.color.trim()
          ? rawMap.grid.color
          : defaults.grid.color,
      opacity:
        Number.isFinite(Number(rawMap?.grid?.opacity))
          ? Math.max(0, Math.min(1, Number(rawMap.grid.opacity)))
          : defaults.grid.opacity,
    },
    viewport: {
      ...defaults.viewport,
      ...(rawMap?.viewport || {}),
    },
    layers: Array.isArray(rawMap?.layers) ? rawMap.layers : defaults.layers,
    pins: Array.isArray(rawMap?.pins) ? rawMap.pins : [],
    links: Array.isArray(rawMap?.links) ? rawMap.links : [],
    shapes: Array.isArray(rawMap?.shapes) ? rawMap.shapes : [],
    regions: Array.isArray(rawMap?.regions) ? rawMap.regions : [],
    drawings: Array.isArray(rawMap?.drawings) ? rawMap.drawings : [],
    groups: Array.isArray(rawMap?.groups) ? rawMap.groups : [],
    measurements: Array.isArray(rawMap?.measurements) ? rawMap.measurements : [],
    measureScales: Array.isArray(rawMap?.measureScales) ? rawMap.measureScales : [],
    activeMeasureScaleId:
      typeof rawMap?.activeMeasureScaleId === 'string'
        ? rawMap.activeMeasureScaleId
        : null,
    activeMeasureScaleIds: Array.isArray(rawMap?.activeMeasureScaleIds)
      ? rawMap.activeMeasureScaleIds.filter(id => typeof id === 'string')
      : [],
  };
  return next;
};
